import List from "@/components/list";
import { Confirm } from "@/components/Confirm";
const Table = args => {
  const { listeners, parent } = args;

  const RCSelectionChange = listeners["selection-change"] || function () { };
  const editContent = listeners["editContent"] || function () { };
  // 删除人员
  async function deletePerson(index) {
    try {
      await Confirm("确定删除选中数据吗?", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      parent.form.classForm.videoIncludeInfoList.splice(index, 1);
    } catch (error) {
      if (error === "cancel") return;
    }
  }

  const Deal = ({ props: { vo } }) => {
    const person = vo.row;
    const index = vo.$index;
    const dealConf = [
      [
        "icon-edit",
        "编辑",
        () => {
          editContent(person, index);
        }
      ],
      [
        "icon-delete",
        "删除",
        () => {
          deletePerson(index);
        }
      ]
    ];

    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip width="50%" content={item[1]} placement="top">
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const AccountTableConfig = [
        // {
        //   type: "selection",
        //   label: "main"
        // },
        {
          label: "视频中出现的人物姓名",
          prop: "includeUserName"
        },
        {
          label: "视频人物单位及职务",
          prop: "includeUnitPosition"
        },
        {
          label: "籍贯",
          prop: "includeNativePlace"
        },
        {
          label: "出现类型",
          prop: "includeTypeName"
        },
        {
          label: "出现时间",
          prop: "includeTime"
        },
        {
          label: "操作",
          render: vo => <Deal vo={vo} />
        }
      ];
  return (
    <List
      {...args}
      empty-text="点击右上角【新增】按钮添加"
      onSelectionChange={RCSelectionChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
